const loading = {
    start: () => {
        document.body.style.cursor = 'wait';
        this.isLoading = true;
    },
    stop: () => {
        document.body.style.cursor = '';
        this.isLoading = false;
    },
    isLoading: false,
}

export default loading;


// WEBPACK FOOTER //
// ./src/utilities/loading.js